import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ButtonPrimary } from '@klarna/bubble-ui';
import { translator } from 'mage-i18n';

const TranslatedButtonPrimary = ({
  tKey,
  t,
  onClick,
  size = 'regular',
  disabled = false,
  loading = false,
}) => (
  <ButtonPrimary size={size} onClick={onClick} disabled={disabled} loading={loading}>
    {t(tKey)}
  </ButtonPrimary>
);

TranslatedButtonPrimary.propTypes = {
  t: PropTypes.func.isRequired,
  tKey: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.string,
};

export default connect(state => ({
  t: translator(state),
}))(TranslatedButtonPrimary);
